import React, { createContext, useContext, useReducer } from 'react';

const confirmationContext = createContext();

const reducer = (state, action) => {
  if (action.show) {
    return {
      isOpen: true,
      title: action.title,
      message: action.message,
      onConfirmation: action.onConfirmation,
      primaryActionLabel: action.primaryActionLabel || 'Confirm',
    };
  } else {
    return { isOpen: false };
  }
};

const ConfirmationProvider = ({ children }) => {
  const [state, dispatchConfirmation] = useReducer(reducer, {
    isOpen: false,
  });

  const value = { state, dispatchConfirmation };

  return (
    <confirmationContext.Provider value={value}>
      {children}
    </confirmationContext.Provider>
  );
};

const useConfirmation = () => {
  return useContext(confirmationContext);
};

export { ConfirmationProvider, useConfirmation };
